import product1 from '../../products-images/bryce.jpg';
import product2 from '../../products-images/angel.jpg';
import product3 from '../../products-images/dorcas.jpg';
import product4 from '../../products-images/recon.jpg';
import product5 from '../../products-images/yosemite.jpg';
import product6 from '../../products-images/alpine.jpg';
import product7 from '../../products-images/outdoor.jpg';


export const productData = [
    {
      img: product1,
      alt: 'Bag',
      name: 'Wildcat',
      desc: 'Bryce Canyon 32L Daypack day bag',
      price: '$83.85',
      button: 'Add to Cart'
    },
    {
      img: product2,
      alt: 'Bag',
      name: 'Wildcat',
      desc: 'A light day bag like an Angel feather',
      price: '$4.34',
      button: 'Add to Cart'
    },
    {
      img: product3,
      alt: 'Bag',
      name: 'Horizon',
      desc:'lightweight Dorcas day bag',
      price: '$24.84',
      button: 'Add to Cart'
    },
    {
      img: product4,
      alt: 'Bag',
      name: 'The North Face',
      desc: 'Recon Urban Daypack',
      price: '$139.75',
      button: 'Add to Cart'
    },
    {
      img: product5,
      alt: 'Bag',
      name: 'Wildcat',
      desc: 'Large Yosemite 42L Daypack',
      price: '$$139.75',
      button: 'Add to Cart'
    },
    {
      img: product6,
      alt: 'Bag',
      name: 'Deuter',
      desc:'Trans Alpine Backpack 30L',
      price: '$199.07',
      button: 'Add to Cart'
    },
    {
      img: product7,
      alt: 'Bag',
      name: 'Outdoor',
      desc:'light backpack 45L',
      price: '$43.47',
      button: 'Add to Cart'
    }
  ];